import React from "react";
import { ToolRendererProps } from "./types";

export const ReadFilesToolRenderer: React.FC<ToolRendererProps> = ({
  args,
  renderWithErrorIfFailed,
  getFallbackText,
  stringifyRender,
}) => {
  let filesRead: string[] = [];
  try {
    filesRead = (args?.filenames || []).map(stringifyRender);
  } catch (e) {
    console.error("Failed to stringify files:", e, args?.filenames);
    filesRead = [];
  }

  return filesRead.length > 0
    ? renderWithErrorIfFailed(
        <ul className="list-none">
          {filesRead.map((file: string, index: number) => (
            <li key={index} className="text-xs text-secondary-n-400">
              {file}
            </li>
          ))}
        </ul>,
      )
    : getFallbackText();
};
